import { HTMLAttributes } from "react";

const tones = {
    neutral: "bg-surface-sunken text-ink-muted border border-border",
    accent: "bg-accent-subtle text-accent border border-accent/20",
    success: "bg-success-subtle text-success border border-success/20",
    warning: "bg-warning-subtle text-warning border border-warning/20",
    danger: "bg-danger-subtle text-danger border border-danger/20",
    info: "bg-info-subtle text-info border border-info/20",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    tone?: keyof typeof tones;
}

export function Badge({ tone = "neutral", className = "", ...props }: BadgeProps) {
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1
                font-sans text-xs font-medium leading-none ${tones[tone]} ${className}`}
            {...props}
        />
    );
}
